// Module
var code = "<div class=\"radio{{class}}\" data-id=\"{{value}}\"><span class=\"value\" data-i18n=\"{{labelI18n}}\">{{label}}</span></div>";
// Exports
module.exports = code;